import{isNotBrowser as a}from"../../constants/index.js";var n=function(n){a||(window.dataLayer=window.dataLayer||[],window.dataLayer.push(n))};export{n as pushDataLayer};
